// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap-binnacle {\n  height: 400px;\n  overflow-y: scroll;\n}\n[dir] .add-code {\n  cursor: copy;\n}\n[dir=ltr] .wrap-item {\n  border-left: 3px solid rebeccapurple;\n}\n[dir=rtl] .wrap-item {\n  border-right: 3px solid rebeccapurple;\n}\n[dir] .con-content--item {\n  padding: 0 !important;\n}\n[dir] .vs-collapse-item--header {\n  padding: 4px !important;\n}\n", ""]);
// Exports
module.exports = exports;
